<template>
    <q-chip v-if="only_time_of_use.selected" label="Free Time" removable
            @remove="only_time_of_use.selected = false"></q-chip>
    <q-chip v-if="only_no_deposit.selected" label="No Deposit" removable
            @remove="only_no_deposit.selected = false"></q-chip>
    <q-chip v-if="only_100_percent_green.selected" label="100% Green" removable
            @remove="only_100_percent_green.selected = false"></q-chip>
    <q-chip v-if="selected_terms.length" :label="`${selected_terms.join(', ')} months`" removable
            @remove="selected_terms = []"></q-chip>
    <q-chip v-if="selected_brands.length" label="Provider" removable
            @remove="selected_brands = []"></q-chip>
  <div class="justify-center">
    <q-chip label="Clear all" removable v-if="only_time_of_use.selected || only_no_deposit.selected || only_100_percent_green.selected || selected_terms.length || selected_brands.length"
          @remove="clear_all"></q-chip>
  </div>
</template>

<script>
import Terms from "src/composables/Terms";
import Brands from "src/composables/Brands";
import Flags from "src/composables/Flags";

export default {
  name: "SelectedFilters",
  setup(){
    const { selected_terms } = Terms();
    const { selected_brands } = Brands();

    const { only_100_percent_green, only_time_of_use, only_no_deposit } = Flags();

    const clear_all = () => {
      only_time_of_use.value.selected = false;
      only_no_deposit.value.selected = false;
      only_100_percent_green.value.selected = false;
      selected_brands.value = [];
      selected_terms.value = [];
    }
    return {
      selected_terms,
      selected_brands,
      only_100_percent_green,
      only_time_of_use,
      only_no_deposit,
      clear_all
    }
  }
}
</script>

<style scoped>

</style>
